/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';
import { RemoveOrderLineItemsDto as DigiworkMaitreDPosDtoOrderV2RemoveOrderLineItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/remove-order-line-items-dto';

export interface RemoveOrderLineItems$Params {
  billId: string;
      body?: DigiworkMaitreDPosDtoOrderV2RemoveOrderLineItemsDto
}

export function removeOrderLineItems(http: HttpClient, rootUrl: string, params: RemoveOrderLineItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
  const rb = new RequestBuilder(rootUrl, removeOrderLineItems.PATH, 'delete');
  if (params) {
    rb.path('billId', params.billId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>;
    })
  );
}

removeOrderLineItems.PATH = '/api/orders/bills/{billId}/order-line-items';
